<style lang="scss">

</style>

<template>
  <!-- eslint-disable -->
  <div class="post-search-page mb-4">
    <section class="d-flex justify-content-end mb-2">
      <b-btn @click="getContacts()" variant="success"><i class="fas fa-sync"></i></b-btn>
    </section>

    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          :items="contacts"
          :fields="headers"
          :current-page="currentPage"
          :per-page="limit"
        >
          <template #cell(name)="data">
            {{ data.item.firstname }} {{ data.item.lastname }}
          </template>

          <template #cell(is_blocked)="data">
            {{ data.item.is_blocked ? 'Yes' : 'No' }}
          </template>

          <template #cell(actions)="data">
            <div class="d-flex justify-content-end" :class="{'disabled': loading}">
              <b-btn v-if="!data.item.is_blocked" @click="showBlockModal(data.item, 'blockUser')" variant="danger">Block</b-btn>
              <b-btn v-else @click="showBlockModal(data.item, 'unBlockUser')" variant="primary">Unblock</b-btn>
            </div>
          </template>
        </b-table>
        <b-row class="p-1">
          <b-col md="6" class="m-1" v-if="contacts.length > limit">
            <b-pagination :total-rows="contacts.length" :per-page="limit" v-model="currentPage" class="my-0"/>
          </b-col>
        </b-row>
        <p v-if="contacts.length === 0" class="col-6 ml-2 my-1">No contacts to show</p>
      </section>
    </b-card>

    <b-modal id="blockUser" title="" hide-footer>
      <block-contact @close="closeModals()" @ok="closeAndRefresh()" :contact="activeContact"></block-contact>
    </b-modal>

    <b-modal id="unBlockUser" title="" hide-footer>
      <warning-modal v-if="activeContact"
                     :title="'Are you sure you want to unblock'" @close="closeModals"
                     @ok="unblockContact(activeContact.user_id)"
                     :subtitle="`${activeContact.firstname} ${activeContact.lastname}?`"></warning-modal>
    </b-modal>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import { mapState } from 'vuex'
import ContactService from '@/services/ContactService'
import HelperService from '@/services/HelperService'
import BlockContact from '@/views/contacts/BlockContact.vue'
import WarningModal from '@/components/modals/WarningModal.vue'

export default {
  name: 'Contacts',
  components: {
    BlockContact,
    WarningModal,
  },
  data() {
    return {
      helperService: new HelperService(),
      loading: false,
      headers: [
        {
          label: 'Name',
          key: 'name',
        },
        {
          label: 'Blocked',
          key: 'is_blocked',
        },
        {
          label: '',
          key: 'actions',
        },
      ],
      contacts: [],
      currentPage: 1,
      limit: 10,
      activeContact: null,
    }
  },
  computed: {
    ...mapState({}),
  },
  watch: {
    currentPage() {
      this.getContacts()
    },
  },
  mounted() {
    this.getContacts()
  },
  methods: {
    getContacts() {
      ContactService.getAll()
        .then(res => {
          this.contacts = res.data;
        })
        .catch(err => {
          console.log('Error getting contacts ', err)
          this.$toast.error('Could not get contacts, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          })
        })
    },
    showBlockModal(contact, modalName) {
      this.activeContact = contact
      this.$bvModal.show(modalName)
    },
    closeModals() {
      this.$bvModal.hide('blockUser')
      this.$bvModal.hide('unBlockUser')
    },
    closeAndRefresh() {
      this.closeModals();
      this.getContacts();
    },
    unblockContact(userId) {
      this.closeModals();

      this.loading = true;
      ContactService.unBlockContact(userId).then(() => {
        this.$toast.success(`Removed Block for ${this.activeContact.firstname} ${this.activeContact.lastname} Successfully`, {
          toastClassName: ['toast-std', 'success-toast'],
        });
      }).catch(err => {
        let error = 'Could not remove contact block, please refresh and try again';

        if (err.response && err.response.statusCode === 404) {
          error = 'Your contact is not in the block list';
        }
        this.$toast.error(error, {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
        this.closeAndRefresh();
      })
    },
  },
}
</script>
